
import { useState } from 'react';
import { useMediaQuery } from "@/hooks/use-media-query";

export const useMobileFilters = () => {
  const [showFilters, setShowFilters] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  
  return {
    showFilters,
    setShowFilters,
    isMobile
  };
};
